import { render, staticRenderFns } from "./new-endorsement-ticket.vue?vue&type=template&id=605a9c97&scoped=true&"
import script from "./new-endorsement-ticket.vue?vue&type=script&lang=js&"
export * from "./new-endorsement-ticket.vue?vue&type=script&lang=js&"
import style0 from "./new-endorsement-ticket.vue?vue&type=style&index=0&id=605a9c97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605a9c97",
  null
  
)

export default component.exports